import { SVGProps } from '@components/Icon/types';

export const Dashboard = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(3, 3)">
      <path
        d="M6 12C7.10457 12 8 12.8954 8 14V16C8 17.1046 7.10457 18 6 18H2C0.895431 18 0 17.1046 0 16V14C0 12.8954 0.895431 12 2 12H6ZM16 8C17.1046 8 18 8.89543 18 10V16C18 17.1046 17.1046 18 16 18H12C10.9643 18 10.113 17.2128 10.0107 16.2041L10 16V10C10 8.89543 10.8954 8 12 8H16ZM12 9.40039C11.6686 9.40039 11.4004 9.66863 11.4004 10V16C11.4004 16.3314 11.6686 16.5996 12 16.5996H16C16.3314 16.5996 16.5996 16.3314 16.5996 16V10C16.5996 9.66863 16.3314 9.40039 16 9.40039H12ZM2 13.4004C1.66863 13.4004 1.40039 13.6686 1.40039 14V16C1.40039 16.3314 1.66863 16.5996 2 16.5996H6C6.33137 16.5996 6.59961 16.3314 6.59961 16V14C6.59961 13.6686 6.33137 13.4004 6 13.4004H2ZM6 0C7.10457 0 8 0.895431 8 2V8C8 9.10457 7.10457 10 6 10H2C0.964349 10 0.113005 9.21278 0.0107422 8.2041L0 8V2C0 0.895431 0.895431 1.61064e-08 2 0H6ZM2 1.40039C1.66863 1.40039 1.40039 1.66863 1.40039 2V8C1.40039 8.33137 1.66863 8.59961 2 8.59961H6C6.33137 8.59961 6.59961 8.33137 6.59961 8V2C6.59961 1.66863 6.33137 1.40039 6 1.40039H2ZM16 0C17.1046 0 18 0.895431 18 2V4C18 5.10457 17.1046 6 16 6H12C10.8954 6 10 5.10457 10 4V2C10 0.895431 10.8954 1.61064e-08 12 0H16ZM12 1.40039C11.6686 1.40039 11.4004 1.66863 11.4004 2V4C11.4004 4.33137 11.6686 4.59961 12 4.59961H16C16.3314 4.59961 16.5996 4.33137 16.5996 4V2C16.5996 1.66863 16.3314 1.40039 16 1.40039H12Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'dashboard';
